import React, { useState } from 'react';
import { faChevronLeft, faChevronRight, faDownload } from '@fortawesome/free-solid-svg-icons';
import LogoItem from 'components/Item/LogoItem/LogoItem';
import SwiperSlider from 'components/SwiperSlider/SwiperSlider';
import { useTranslation } from 'react-i18next';
import { SwiperSlide } from 'swiper/react';
import Modal from 'components/modal/Modal';
import ModalFile from '../../espace-automotor-offer/Card/ModalFile/ModalFile';
import useHttp from 'utils/hooks/useHttp';
import moment from 'moment';
import { notify } from 'utils/marketplace';
import Spinner from 'components/spinner/Spinner';
import ModalFileNotFond from '../../espace-automotor-offer/Card/ModalFileNotFond/ModalFileNotFond';
import { useDeviceDetect } from 'utils/hooks/deviceDetect';
import DownloadMultipleSuplierFilesModal from './DownloadMultipleSuplierFilesModal/DownloadMultipleSuplierFilesModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  data
  title
  length
  suppliersWithPrice
};

const TariffsAutomotorSwiper: React.FC<Props> = (props) => {

  const { t } = useTranslation();
  const http = useHttp();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openModalDownloadMultipleFile, setOpenModalDownloadMultipleFile] = useState<boolean>(false);
  const userInfo = JSON.parse(localStorage.getItem('userData')!);
  const [loading, setLoading] = useState(true);
  const [supplierName, setSupplierName] = useState('');
  const [supplierNameModal, setSupplierNameModal] = useState('');
  const [openModalNotFile, setOpenModalNotFile] = useState(false);
  const { isMobile, isTablet, isDesktop } = useDeviceDetect();
  const minVisibleSlides = 15;

  function download(item, type) {


    // if (userInfo?.is_using_tariffs_tables_v2) {
    if (!item.has_price) {
      console.log('item', item);
      setOpenModalNotFile(true);
      setSupplierNameModal(item.supplier_name);
      http.automotorTariff.gePriceRequestAccess({ codfou: item.codfou, type: type, supplier_name: item.supplier_name });

      return;
    }

    setLoading(true);
    setSupplierName(item.supplier_name);

    setOpenModal(true);
    http.automotorTariff.getFileV2({ codfou: item.codfou, type: type, supplier_name: item.supplier_name }).then((res) => {
      const element = document.createElement('a');

      const file = new Blob([res.data], { type: res.data.type });

      element.href = URL.createObjectURL(file);
      element.download = item.supplier_name + `_${moment().format('MM-DD-YY')}`;
      element.click();
    })
      .catch(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        notify(t('_please_contact_seller'));
        setOpenModal(false);
      })
      .finally(() => {
        setLoading(false);
        setOpenModal(false);
      });

    return;
    // }

    // setLoading(true);
    // setSupplierName(item.supplier_name);
    // http.automotorTariff.getFile(item.file_id, { name: item.supplier_name }).then((res) => {
    //   const element = document.createElement('a');
    //   const file = new Blob([res.data], { type: res.data.type });

    //   element.href = URL.createObjectURL(file);
    //   element.download = item.supplier_name + `_${moment().format('MM-DD-YY')}`;
    //   element.click();
    // }).catch(() => {
    //   window.scrollTo({ top: 0, behavior: 'smooth' });
    //   notify(t('_please_contact_seller'));
    // }).finally(() => {
    //   setLoading(false);
    // });

  }

  function show(index: string, type: 'block' | 'none') {
    const elements = document.getElementsByClassName(`tooltip-${index}`);

    for (let i = 0; i < elements.length; i++) {
      (elements[i] as HTMLElement).style.setProperty('display', type, 'important');
    }
  }

  return <div className="items">
    <div className="item-title">
      {props.title == 'suppliers' ? t('_equipment_manufacturers').toUpperCase() : t('_manufacturers').toUpperCase()}
      {(props.title == 'suppliers' && props.suppliersWithPrice.length) ?
        <div onClick={() => setOpenModalDownloadMultipleFile(true)} className="download_multiple"
          onMouseEnter={() => {

            show('download_multiple', 'block');

          }}
          onMouseLeave={() => {

            setTimeout(() => {
              show('download_multiple', 'none');
            }, 100);

          }}
        >
          <FontAwesomeIcon icon={faDownload} />

          <div className="tooltip-download_multiple">
            {t('_download_multiple')}
          </div>


        </div> : null}
    </div>
    {props.data.length ?
      <SwiperSlider
        navigation={!(isMobile || isTablet) && props.length > minVisibleSlides}
        pagination={isMobile || isTablet}
        autoplay={props.length > minVisibleSlides}
        loop={props.length > minVisibleSlides}
        iconsArrowRight={faChevronRight}
        iconsArrowLeft={faChevronLeft}
        slidesPerView={props.length < minVisibleSlides ? props.length : 'auto'}
        slidesToMove={5}
        allowTouchMove={!isDesktop}
      >
        {props.data.map((item, index: number) => {
          return (
            <SwiperSlide className="swiper-slide" key={index} >
              <div className="item-body">
                {loading && item.supplier_name === supplierName ? <Spinner class="small automotor-tariff-spinner" /> :
                  <LogoItem image={item.supplier_logo} hasPrice={item.has_price} item={item} tooltipIndex={item.codfou + index + item.type} name={item.supplier_name} onClick={() => download(item, item.type)} />
                }
              </div>
            </SwiperSlide>
          );
        })
        }

      </SwiperSlider>
      : <div className="no-data"> {t('_no_data')} </div>
    }
    <Modal
      openModal={openModal}
      setOpenModal={setOpenModal}
      shouldCloseOnOverlayClick={false}
      childrenComponent={
        <ModalFile />
      }
    />
    <Modal
      openModal={openModalNotFile}
      setOpenModal={setOpenModalNotFile}
      shouldCloseOnOverlayClick={false}
      childrenComponent={
        <ModalFileNotFond setModalNotFile={setOpenModalNotFile} name={supplierNameModal} />
      }
    />
    <Modal
      openModal={openModalDownloadMultipleFile}
      setOpenModal={setOpenModalDownloadMultipleFile}
      childrenComponent={
        <DownloadMultipleSuplierFilesModal closeModal={setOpenModalDownloadMultipleFile} tariffs={props.suppliersWithPrice} />
      }
    />
  </div>;

};

export default TariffsAutomotorSwiper;


